import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`伊雲谷數位科技(6689)為台灣唯一獲得 AWS 認證，同時提供技術諮詢及培訓輔導的核心級夥伴，推動超過 1000 家客戶，以雲端加值服務開啟數位轉型。產業服務經驗跨足零售電商、媒體、遊戲、金融及高科技製造等領域，版圖亦遍及台港、中國大陸、菲律賓、新加坡、馬來西亞、泰國、美國等亞太地區，是 Gartner〈Market Guide: 2020 亞太區指標性雲端服務商〉唯一入榜的台灣廠商。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      